import { WaterCheckOutlineIcon } from './WaterCheckOutlineIcon';

/**
 * author: Colton Wiscombe
 * id E555BA93-F6A7-4B19-A4F8-132585E14850
 * name water-check-outline
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-check-outline.svg
 * tags
 */
export const BloodCheckOutlineIcon = WaterCheckOutlineIcon;
export default BloodCheckOutlineIcon